var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReklaimWordmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 14,
    viewBox: "0 0 107 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3001 2.40656L43.8535 0.00166429L35.5125 8.19662V0H32.051V14H46.3035V10.5999H37.959L46.3001 2.40656Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.73653C8.9137 0 10.4216 0.559202 11.3789 1.5195C12.2125 2.32002 12.6412 3.40014 12.6412 4.77983V4.81979C12.6412 6.96006 11.4806 8.37969 9.70832 9.1203L13.1088 14H8.55113L5.68099 9.7594H3.94941V14H0V0ZM6.55524 6.7204C7.90051 6.7204 8.67311 6.07965 8.67311 5.05611V5.01617C8.67311 3.91608 7.85985 3.35188 6.53491 3.35188H3.94941V6.71208L6.55524 6.7204Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4347 0H27.8966V3.30029H20.3434V5.42059H27.185V8.47956H20.3434V10.6997H28V14H16.4347V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3528 0H54.3039V10.5999H61.2065V14H50.3528V0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8576 0H73.6613L79.7286 14H75.4928L74.4542 11.5036H68.9579L67.9413 14H63.7869L69.8576 0ZM73.3224 8.47956L71.7314 4.50357L70.1236 8.48288L73.3224 8.47956Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2374 0H87.2156V14H83.2459L83.2374 0Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8496 0H96.0261L99.4265 5.42059L102.827 0H107V14H103.071V5.95982L99.4265 11.4403H99.3452L95.7194 6.00142V14.0017H91.8496V0Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReklaimWordmark);
export default __webpack_public_path__ + "static/media/reklaim-wordmark.80c7f77308b1c084db54c2092036808c.svg";
export { ForwardRef as ReactComponent };